import { Switch, message, notification } from 'antd';
import { FC, useCallback, useState } from 'react';
import { parseIfObject } from 'src/utils/common';
import { updateUser } from 'src/utils/firebase/firebase-short-cut';
import { AuditLogger } from 'src/utils/audit-logger';

const auditLogger = AuditLogger.getInstance();

interface DeadlineNotificationToggleCellProps {
  id: string;
  value: boolean;
}

const DeadlineNotificationToggleCell: FC<DeadlineNotificationToggleCellProps> = ({ id, value }) => {
  const [loading, setLoading] = useState(false);

  const handleSwitchChange = useCallback(async (value: any, userId: string) => {
    setLoading(true);
    try {
      await updateUser(userId, { deadlineNotification: value });
      message.success('변경완료.');
    } catch (error: any) {
      notification.error({
        message: '에러발생',
        description: error.message,
      });
      auditLogger.log({
        action: 'UPDATE',
        entity: 'user',
        entityId: userId,
        summary: `사용자 관리 - user/${userId}.deadlineNotification:: ${parseIfObject(error)}`,
        level: 'error',
      });
    }
    setLoading(false);
  }, []);

  return <Switch loading={loading} checked={value} onChange={(v) => handleSwitchChange(v, id)} />;
};

export default DeadlineNotificationToggleCell;
